import"./Rating.css.ts.vanilla.css";var r="var(--spui4z4)",s="var(--spui4z5)",a="spui4z6";export{r as currentRating,s as cursorDisplay,a as stars};
